// extracted by mini-css-extract-plugin
export default {"add":"HuntFormPlan_add__tUi9l","warning":"HuntFormPlan_warning__hJrml"};